/**
 * @generated SignedSource<<b7092f6e29beff2bfff909bd343bdde3>>
 * @relayHash 1dceff4af9e3ffef9c8dba25cb61be3e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1dceff4af9e3ffef9c8dba25cb61be3e

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type Country = "CH" | "DE";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type fetchServiceMappingsQuery$variables = Record<PropertyKey, never>;
export type fetchServiceMappingsQuery$data = {
  readonly appointmentTypeMappings: ReadonlyArray<{
    readonly appointmentType: AppointmentType;
    readonly capacityPoints: number;
    readonly isFlatLength: boolean;
    readonly slotCount: number | null;
  }>;
  readonly serviceMappings: ReadonlyArray<{
    readonly allowedAppointmentTypes: ReadonlyArray<AppointmentType>;
    readonly isAllowedInCountries: ReadonlyArray<Country>;
    readonly isRequestRelevant: boolean;
    readonly isUrgent: boolean;
    readonly service: Service;
    readonly specialty: ServiceSpecialty;
  }>;
};
export type fetchServiceMappingsQuery = {
  response: fetchServiceMappingsQuery$data;
  variables: fetchServiceMappingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ServiceMappingOutput",
    "kind": "LinkedField",
    "name": "serviceMappings",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "service",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialty",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllowedInCountries",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRequestRelevant",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUrgent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedAppointmentTypes",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AppointmentTypeMappingOutput",
    "kind": "LinkedField",
    "name": "appointmentTypeMappings",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appointmentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "capacityPoints",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isFlatLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slotCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchServiceMappingsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "fetchServiceMappingsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "1dceff4af9e3ffef9c8dba25cb61be3e",
    "metadata": {},
    "name": "fetchServiceMappingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "109583a0a9c7a9c995f35f8b0e2f07b0";

export default node;
